export var StreamType = /*#__PURE__*/ function(StreamType) {
    StreamType["WITH_OFFSET"] = "WITH_OFFSET";
    StreamType["WITH_CURSOR"] = "WITH_CURSOR";
    return StreamType;
}({});

//# sourceMappingURL=types.js.map